'use client'
import React from 'react'
import type { PdfBlock as PdfBlockProps } from '@/payload-types'
import { PdfCard } from '@/ui/components/PdfCard'

interface ExtendedPdfBlockProps extends PdfBlockProps {}

export const PdfBlock: React.FC<ExtendedPdfBlockProps> = ({ title, files }) => {
  return (
    <div>
      {title && <h2 className="!text-body-S-regular !text-text-faded mb-4">{title}</h2>}
      <div className="flex flex-col md:flex-row gap-2 flex-wrap">
        {files?.map((file, index) => (
          <PdfCard
            fileTitle={file.fileTitle}
            pdfFiles={file.pdfFiles}
            fileDescription={file.fileDescription}
            key={index}
          ></PdfCard>
        ))}
      </div>
    </div>
  )
}
